import { t } from "@impero-com/common/utils/i18n";
import { ChartData, StackedBarChart, Tooltip } from "@impero-com/ui";
import { rawPalette } from "@impero-com/ui/styles/theme.css";

import { ExistingControlActivityStatus } from "utils/controlResults/activityStatusUtils";

import { ActivityNumbers } from "../activityPieChart";

import * as theme from "./theme.css";

interface ActivityStackedBarChartProps {
    numbers: ActivityNumbers;
    activitiesUrl: string;
    getActivitiesByStatusUrl: (
        statusKey: ExistingControlActivityStatus | null
    ) => string;
}

export function ActivityStackedBarChart({
    numbers,
    getActivitiesByStatusUrl,
    activitiesUrl,
}: ActivityStackedBarChartProps) {
    const data: Array<ChartData<ExistingControlActivityStatus>> = [
        {
            label: t("Report_Status_Completed"),
            value: numbers.completed,
            color: rawPalette.base.green[600],
            statusKey: "Completed",
        },
        {
            label: t("Report_Status_WorkflowStatus_CompletedAfterDue"),
            value: numbers.completedAfterDue,
            color: rawPalette.base.green[200],
            statusKey: "CompletedAfterDueDate",
        },
        {
            label: t("Report_Status_Overdue"),
            value: numbers.overdue,
            color: rawPalette.base.red[500],
            statusKey: "Overdue",
        },
        {
            label: t("Report_Status_Pending"),
            value: numbers.pending,
            color: rawPalette.base.orange[500],
            statusKey: "Pending",
        },
        {
            label: t("Report_Status_WorkflowStatus_Future"),
            value: numbers.toBeSent,
            color: rawPalette.base.lightBlue[500],
            statusKey: null, // When we want to link to activities view we do not have any future activities to show in the table view
        },
    ];

    const sum = data.reduce((prev, entry) => prev + entry.value, 0).toString();
    const currentActivitiesCount = Number(sum) - numbers.toBeSent;
    const totalActivitiesTooltip = (
        <>
            {t("Activities_Tooltip_Current")}: {currentActivitiesCount}
            <br />
            {t("Activities_Tooltip_Future")}: {numbers.toBeSent}
            <br />
            {t("Activities_Tooltip_Total")}: {sum}
        </>
    );
    return (
        <div className={theme.activitiesStackedBarChart}>
            <StackedBarChart
                data={data}
                standardColor="black"
                getActivitiesByStatusUrl={getActivitiesByStatusUrl}
            />
            <Tooltip title={totalActivitiesTooltip}>
                <a href={activitiesUrl}>
                    <span>{sum}</span>
                </a>
            </Tooltip>
        </div>
    );
}
